import { render, staticRenderFns } from "./costDocument.vue?vue&type=template&id=5c4b745b&scoped=true"
import script from "./costDocument.vue?vue&type=script&lang=js"
export * from "./costDocument.vue?vue&type=script&lang=js"
import style0 from "./costDocument.vue?vue&type=style&index=0&id=5c4b745b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b745b",
  null
  
)

export default component.exports